import { usePrioritizeSectionsContext } from '../../filters/contexts/PrioritizeSectionsContext';

/**
 * Hook for managing prioritize section expansion and visibility state.
 * Must be used within PrioritizeSectionsProvider.
 * @returns {Object} - Prioritize sections state and toggle functions
 */
export function usePrioritizeSections() {
  return usePrioritizeSectionsContext();
}
